var components;
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isShow)?_c('v-uni-view',{ref:"ani",staticClass:"uni-transition",class:[_vm.ani.in],style:('transform:' + _vm.transform + ';' + _vm.stylesObject),on:{"click":function($event){
arguments[0] = $event = _vm.$handleEvent($event);
(_vm.change).apply(void 0, arguments)
}}},[_vm._t("default")],2):_vm._e()}
var recyclableRender = false
var staticRenderFns = []

export { render, staticRenderFns, recyclableRender, components }